import React from 'react';
import PropTypes from 'prop-types';

import Flickity from 'react-flickity-component';
import 'flickity/dist/flickity.css';

const CarTeaserLink = ({ car, children }) => {
    if (car.allowDetailPage) {
        return (
            <a className="estate-teaser__link" href={car.url}>{children}</a>
        );
    }

    return children;
};

class CarTeaser extends React.Component {
    componentDidMount = () => {
        if (this.props.car.allowDetailPage) {
            // this loads all the images when they click the arrows
            this.flickity.on('change', () => {
                this.flickity.cells.forEach((cell) => {
                    cell.element.style.backgroundImage = `url('${cell.element.dataset.image}')`;
                });
            });

            // this is for the initial image.
            this.flickity.on('select', () => {
                const { selectedElement } = this.flickity;

                if (selectedElement) {
                    selectedElement.style.backgroundImage = `url('${selectedElement.dataset.image}')`;
                }
            });

            let offset = 1;
            const update = () => {
                this.flickity.resize();

                if (offset < 5) {
                    setTimeout(() => {
                        update();
                    }, 500 * offset);
                }

                offset += 1;
            };

            setTimeout(() => {
                update();
            }, 500);
        }
    };

    // Depeding on whether the estate is available or not we render Flickity.
    renderImage = () => {
        if (this.props.car.allowDetailPage) {
            return (
                <Flickity
                    className="estate-teaser-image-carousel"
                    options={{
                        pageDots: false,
                        wrapAround: true,
                    }}
                    flickityRef={c => this.flickity = c}
                >
                    {this.props.car.images.slice(0, window.estateTeaserMaxPreviewImages).map((image) => {
                        if (this.props.car.allowDetailPage) {
                            return (
                                <a
                                    className="estate-teaser-image-carousel__item"
                                    href={this.props.car.url}
                                    aria-hidden="true"
                                    data-image={image}
                                    key={image}
                                />
                            );
                        }

                        return (
                            <div
                                className="estate-teaser-image-carousel__item"
                                data-image={image}
                                key={image}
                            />
                        );
                    })}
                </Flickity>
            );
        } else {
            return (
                <div
                    className="estate-teaser-image-carousel__item"
                    style={{ backgroundImage: `url(${this.props.car.images[0]})` }}
                />
            );
        }
    };

    render = () => {
        const { car } = this.props;

        return (
            <div className="estate-teaser">

                <div className="estate-teaser__images-wrapper">
                    { this.renderImage() }
                </div>

                <CarTeaserLink car={car}>
                    <div className="estate-teaser__metadata">
                        <div className="estate-teaser__statistics">
                            <div className="estate-teaser__statistic">
                                <img src="https://img.icons8.com/windows/64/000000/speed.png"/>
                                {car.mileage} km
                            </div>
                            <div className="estate-teaser__statistic">
                                <img src="https://img.icons8.com/windows/64/000000/today.png" />
                                {car.year}
                            </div>
                        </div>
                        {Boolean(car.displayPrice) && car.allowDetailPage && (
                            <div className="estate-teaser__price font-supplementary--bold">
                                {car.price}
                            </div>
                        )}
                        {car.allowDetailPage && Boolean(car.displayPrice) === false && (
                            <div className="estate-teaser__price font-supplementary--bold">
                                {window.priceFalse}
                            </div>
                        )}
                    </div>
                    <div className="estate-teaser__content">
                        <div className="estate-teaser__title font-supplementary--bold">
                            {car.title}
                        </div>
                    </div>
                </CarTeaserLink>
            </div>
        );
    };
}

CarTeaser.propTypes = {
    car: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        price: PropTypes.string,
        year: PropTypes.string,
        mileage: PropTypes.string,
        allowDetailPage: PropTypes.bool,
        images: PropTypes.arrayOf(
            PropTypes.string,
        ),
    }).isRequired,
};

export { CarTeaser };
